import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'alm-react-components';

const FaqList = ({questions}: any) => {
  return (
    <div className="faq-list">
      {questions?.faqList?.map((faq: any) => {
          return (
            <Accordion type="single" collapsible className="w-full mt-1" key={faq?.questionId}>
              <AccordionItem value="item-1" className="border-0">
                <AccordionTrigger className="mb-3 bg-[#212930] px-4 rounded-lg program-accordion commitment-accordion text-base font-barlowLight py-3 hover:no-underline">
                  {faq?.question}
                </AccordionTrigger>
                <AccordionContent className="text-base font-barlowLight ms-5">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: faq?.answer,
                    }}
                    className="text-editor-dynamic-class "
                  />
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          );
        })}
    </div>
  );
};

export default FaqList;
